import { useCallback } from 'react'
import { getEnv } from '../../../config/env'

const REACT_APP_WP_CONTENT_CREATOR_URL = getEnv('REACT_APP_WP_CONTENT_CREATOR_URL')

export const useWordpressTokenGenerator = () => {
  const openWordpressUrl = useCallback(() => {
    window.open(`${REACT_APP_WP_CONTENT_CREATOR_URL}/wp-admin/edit.php?post_type=page`)
  }, [])

  return {
    openWordpressUrl,
  }
}
